// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main__container-f273cd {
  position: fixed;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: auto minmax(350px, 1fr) auto;
  grid-auto-rows: 100%;
  /* AVERAGE */
  --average-background: linear-gradient(0deg, var(--addition-110_20), var(--addition-110_20)),
    linear-gradient(0deg, var(--chat-background-average), var(--chat-background-average));
}`, "",{"version":3,"sources":["webpack://./src/main/MainView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mDAAA;EACA,oBAAA;EAEA,YAAA;EACA;yFAAA;AACF","sourcesContent":[".container {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: auto minmax(350px, 1fr) auto;\n  grid-auto-rows: 100%;\n\n  /* AVERAGE */\n  --average-background: linear-gradient(0deg, var(--addition-110_20), var(--addition-110_20)),\n    linear-gradient(0deg, var(--chat-background-average), var(--chat-background-average));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `main__container-f273cd`
};
module.exports = ___CSS_LOADER_EXPORT___;
